<template>
  <div :class="'col col-xs-12 col-sm-'+colSpan+' col=md-'+colSpan+' col-lg-'+colSpan">
    <div class="row">
      <q-table
        :data="productDetail.StockBlock"
        :columns="columns"
        row-key="name"
      >
        <template v-slot:top="props">
          <div class="col-3 q-table__title">庫位</div>
          <q-btn
            v-show="false"
            color="blue"
            icon="create"
            label="增加櫃位"
            @click="productAddStock"
          ></q-btn>
          <q-btn
            v-if="canEdit && false"
            color="green"
            icon="save"
            :label="(methodType === 'modify')? '調整庫存': '儲存' "
            @click="productUpdateStock"
          ></q-btn>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="default_stock" :props="props">
              <q-toggle v-model="props.row.default_stock"/>
            </q-td>
            <q-td key="title" :props="props">
              <q-input filled v-model="props.row.Title" :dense="false" />
            </q-td>
            <q-td key="stock" :props="props">
              <q-input filled readonly v-model="props.row.Stock" :dense="false" />
            </q-td>
            <q-td key="action" :props="props">
              <q-btn
                v-if="canEdit"
                color="black"
                label="加入待領"
                class="q-mr-xs"
                @click="handleAddPreCollar(props.row)"
                ></q-btn>
              <q-btn
                v-if="canEdit"
                color="green"
                label="移庫"
                @click="showMoveStock = true, productSetStockSelect(props.row)"
                class="q-mr-xs"
                ></q-btn>
              <q-btn
                v-if="canEdit"
                color="blue"
                label="盤點"
                @click="showModify = true, productSetStockSelect(props.row)"
                class="q-mr-xs"
                ></q-btn>
              <q-btn
                v-if="canEdit"
                color="red"
                icon="delete"
                label=""
                @click="handleStockDelete(props.row)"
                class="q-mr-xs"
                ></q-btn>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <!-- 移庫 -->
    <q-dialog v-model="showMoveStock" full-width full-height>
      <StockMove />
    </q-dialog>
    <!-- 盤點 -->
    <q-dialog v-model="showModify" full-height>
      <StockModify />
    </q-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { showSystemNotify } from '@/utils'
  import StockMove from './StockMove'
  import StockModify from './StockModify'
  export default {
    name: "StockLocker",
    components: { StockModify, StockMove },
    props: {
      colSpan: {
        type: Number,
        default: 12
      },
      canEdit: {
        type: Boolean,
        default: false
      },
      methodType: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        selectStock: {},
        showMoveStock: false,
        showModify: false,
        columns: [
          { name: 'default_stock', align: 'center', label: '預設庫位', field: 'default_stock' },
          { name: 'title', align: 'center', label: '庫位名稱', field: 'Title' },
          { name: 'stock', label: '庫存', field: 'Stock', align: 'center' },
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
      }
    },
    computed: {
      ...mapGetters(['productDetail'])
    },
    methods: {
      handleStockDelete(block) {
        if (Number.parseInt(block.Stock) === 0) {
          this.$q.dialog({
            dark: true,
            title: '確認！',
            message: '是否確認刪除此庫位資料？',
            cancel: true,
            persistent: true
          }).onOk(() => {
            this.$store.dispatch('productDeleteStock', block.ID).then(res => {
              showSystemNotify(res)
              this.$router.go(this.$route.fullPath)
            })
          })
        } else {
          this.$q.dialog({
            dark: true,
            title: '警告！',
            message: '此庫位尚有庫存數量請先做[移庫]!',
            cancel: true,
            persistent: true
          })
        }
      },
      handleAddPreCollar(prod) {
        this.$store.dispatch("collarAddProductToWait", {ProductID: this.productDetail.id, ProductStockID: Number.parseInt(prod.ID) })
        .then( _ => {
          this.$store.dispatch("collarGetCountInWait")
        })
      },
      ...mapActions(['productAddStock', 'productUpdateStock', 'productSetStockSelect'])
    }
  }
</script>
